import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { AddApiPermission } from "../../redux/Actions/userStatusService";

function EditUserPopup({
  open,
  onClose,
  selectedUser,
  portal,
  userInformation,
  userPermissions,
  userPerm = [],
}) {
  const dispatch = useDispatch();
  const [userEmail, setUserEmail] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const parentRoleId = localStorage.getItem("parentId");

  useEffect(() => {
    // Initialize selectedPermissions with userPerm data
    if (Array.isArray(userPerm)) {
      const initialPermissions = userPerm.reduce((acc, permission) => {
        acc[permission.apiName] = permission.canAccess;
        return acc;
      }, {});
      setSelectedPermissions(initialPermissions);
    }

    if (selectedUser?.childUserRole?.user?.email) {
      setUserEmail(selectedUser?.childUserRole?.user?.email);
    }
  }, [selectedUser, userPerm]);

  const handlePermissionChange = (apiName) => {
    setSelectedPermissions((prevPermissions) => ({
      ...prevPermissions,
      [apiName]: !prevPermissions[apiName],
    }));
  };

  const handleSubmit = async () => {
    if (
      !userPermissions?.length ||
      Object.values(selectedPermissions).includes(true)
    ) {
      const addedUser = selectedUser;

      if (addedUser) {
        const permissionsArray = Object.entries(selectedPermissions)
          .filter(([, canAccess]) => canAccess)
          .map(([apiName]) => ({ apiName, canAccess: true }));

        const permissions = permissionsArray.length
          ? [
              {
                childRoleId: addedUser?.childUserRole?.id,
                permissions: permissionsArray,
              },
            ]
          : [];

        const permissionPayload = {
          parentRoleId,
          childrenPermissions: permissions,
        };

        await dispatch(
          AddApiPermission({ body: permissionPayload, type: portal })
        );
      }
    }

    onClose();
  };

  const isFormValid =
    userEmail &&
    (!userPermissions?.length ||
      Object.values(selectedPermissions).includes(true));

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ width: 600 }}>Edit User</DialogTitle>
      <DialogContent>
        <TextField
          label="User Email"
          type="email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          fullWidth
          margin="dense"
          required
          error={!userEmail}
          helperText={!userEmail ? "Email is required" : ""}
        />

        {userPermissions?.length > 0 && (
          <FormGroup>
            <p>Select Permissions:</p>
            {userPermissions.map((permission) => (
              <FormControlLabel
                key={permission.apiName}
                control={
                  <Checkbox
                    checked={!!selectedPermissions[permission.apiName]}
                    onChange={() => handlePermissionChange(permission.apiName)}
                  />
                }
                label={permission.apiName}
              />
            ))}
          </FormGroup>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!isFormValid}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditUserPopup;
